import type { MagentoApiSetBillingAddressOnCartMutationResponse } from "@jti/magento-api-v2";
import type { ApiMagentoAddress } from "@jti/magento-types";

import type { MagentoApiBuilder } from "../magentoApiSlice";

type SetBillingAddressOnCartPayload = {
  cartId: string;
  address: ApiMagentoAddress;
};

export const setBillingAddressOnCartEndpoint = (builder: MagentoApiBuilder) => ({
  setBillingAddressOnCart: builder.mutation<
    MagentoApiSetBillingAddressOnCartMutationResponse,
    SetBillingAddressOnCartPayload
  >({
    query: ({ cartId, address }) => ({
      method: "setBillingAddressOnCart",
      params: [{ cartId, address }],
    }),
  }),
});
